import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Logo from "../components/Logo";
import Logout from "../layouts/Logout";

function Topbar({ onToggleSidebar }) {
  const [context, setContext] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Priority 1: get from navigation state
    if (location.state?.context) {
      setContext(location.state.context);
      sessionStorage.setItem(
        "selectedContext",
        JSON.stringify(location.state.context)
      );
    } else {
      // Priority 2: get from sessionStorage
      const saved = sessionStorage.getItem("selectedContext");
      if (saved) setContext(JSON.parse(saved));
    }

    // Listen for changes in sessionStorage (multi-tab/window support)
    const handleStorageChange = () => {
      const updated = sessionStorage.getItem("selectedContext");
      setContext(updated ? JSON.parse(updated) : null);
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("session-storage-update", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("session-storage-update", handleStorageChange);
    };
  }, [location.state]);

  const handleNewWindow = () => {
    const appUrl = window.location.origin + "/select-context";
    window.open(appUrl, "_blank", "noopener,noreferrer,width=1200,height=800");
  };

  return (
    <header id="page-topbar">
      <div className="navbar-header">
        {/* Logo */}
        <Logo onToggleSidebar={onToggleSidebar} />
        {/* Menu */}
        <div className="d-flex justify-content-between menu-sm px-3 ms-auto">
          <div className="d-flex align-items-center gap-2">
            {/* Apps Dropdown */}
            {/* Features Dropdown */}
          </div>

          {/* === Context Display === */}
          <div className="d-flex align-items-center gap-3 ms-3">
            {context ? (
              <div className="fw-semibold">
                <span className="me-2">
                  <i className="fas fa-calendar-alt text-primary me-1"></i>
                  FY: {context.fy}
                </span>
                <span className="me-2">
                  <i className="fas fa-building text-success me-1"></i>
                  Company: Hub Business Center
                </span>
                <span className="me-2">
                  <i className="fas fa-code-branch text-warning me-1"></i>
                  Branch: {context.branch_name || context.branch}
                </span>
                <button
                  className="btn btn-outline-primary ms-2 fw-bold"
                  onClick={handleNewWindow}
                >
                  + New Window
                </button>
              </div>
            ) : (
              <div className="text-muted small">No context selected</div>
            )}
          </div>

          <div className="d-flex align-items-center gap-2">
            {/* Search */}
            {/* <form className="app-search d-none d-lg-block">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                />
                <span className="fab fa-sistrix fs-17 align-middle"></span>
              </div>
            </form> */}

            {/* Notifications */}
            <div className="dropdown d-inline-block">
              <button
                type="button"
                className="btn btn-sm top-icon"
                id="page-header-notifications-dropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-bell align-middle"></i>
                <span className="btn-marker">
                  <i className="marker marker-dot text-danger"></i>
                </span>
              </button>
              {/* Notification dropdown content skipped for brevity */}
            </div>

            {/* Activities */}
            {/* <div className="d-inline-block activities">
              <button
                type="button"
                className="btn btn-sm top-icon"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvas-rightsidabar"
              >
                <i className="fas fa-table align-middle"></i>
              </button>
            </div>
 */}
            {/* Profile */}
            <Logout />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Topbar;
